<template>
  <div class="overflow-x-hidden bg-bianca">
    <router-view name="content" />
  </div>
</template>
